// import Ishwor from '../images/members/Ishwor.jpg Excoordinator'
// import Prabesh from '../images/members/Prabesh.jpg Sectartary'
// import Sujal from '../images/members/Sujal.jpg Lead RA'
// import Kashmir from "../images/members/Kashmir.jpg Lead software Coorsinator"
// import Ruby from "../images/members/Ruby.jpg Lead Grpahics"
// import Shreya from "../images/members/Shreya.jpg Laed Marketing Head"


import khemraj from '../images/members/khemraj.jpg'
import jivan from '../images/members/Jivan.jpg'
import jatin from '../images/members/Jatin.jpg'
import shirshak from "../images/members/shirshak.jpg"
import dipu from "../images/members/dipu.jpg"
import rajendra from "../images/members/rajendra.jpg"


const Alumni = [
    {
        Image: khemraj,
        Name: "Khemraj Shrestha",
        Role: "Ex Co-ordinator",
        Year: "BCT 077"
    },
    {
        Image: jivan,
        Name: "Jivan Acharya",
        Role: "Ex Lead Research Advocate",
        Year: "BCT 077"
    },
    {
        Image: jatin,
        Name: "Jatin Raut",
        Role: "Ex Lead Graphics Designer ",
        Year: "BEI 078"
    },
    {
        Image: shirshak,
        Name: "Shirshak Acharya",
        Role: "Ex Co-ordinator",
        Year: "BEI 076"
    },
    {
        Image: dipu,
        Name: "Dipu Dahal",
        Role: "Ex Secretary",
        Year: "BEI 076"
    },
    {
        Image: rajendra,
        Name: "Rajendra Baskota",
        Role: "Ex Lead Research Advocate",
        Year: "BEI 076"
    }
]

export default Alumni